module.exports = __webpack_public_path__ + "img/xpsj.77d36e68.png";